import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { usePageType } from '@aibees/elephant/hooks/use-page-type';
import { SearchType } from '@aibees/elephant/types';
import { useMemo } from 'react';

export function useSearchType(searchTypeOverride?: SearchType): SearchType {
  const searchTypeFromRoute = useSearchTypeFromRoute();
  const { isPeoplePage } = usePageType();

  return useMemo(() => {
    if (searchTypeOverride) return searchTypeOverride;
    if (isPeoplePage) return SearchType.People;
    return searchTypeFromRoute ?? SearchType.Company;
  }, [searchTypeOverride, searchTypeFromRoute, isPeoplePage]);
}
